// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Store = require("../Store.bs.js");
var Js_exn = require("bs-platform/lib/js/js_exn.js");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ApolloError = require("./ApolloError.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var PromiseUtils = require("../PromiseUtils.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Client = require("@apollo/client");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_AsyncData = require("relude/src/Relude_AsyncData.bs.js");
var Js_null_undefined = require("bs-platform/lib/js/js_null_undefined.js");
var Caml_js_exceptions = require("bs-platform/lib/js/caml_js_exceptions.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var ApolloUploadClient = require("apollo-upload-client");
var Ws = require("@apollo/client/link/ws");

var InMemory = {};

var Cache = {
  InMemory: InMemory
};

function make(uri, $$fetch, fetchOptions, credentials, headers, includeExtensions, param) {
  return ApolloUploadClient.createUploadLink({
              uri: Js_null_undefined.fromOption(uri),
              fetch: Js_null_undefined.fromOption($$fetch),
              fetchOptions: Js_null_undefined.fromOption(fetchOptions),
              credentials: Js_null_undefined.fromOption(credentials),
              headers: Js_null_undefined.fromOption(headers),
              includeExtensions: Js_null_undefined.fromOption(includeExtensions)
            });
}

var Upload = {
  make: make
};

var Context = {};

function make$1(uri, reconnect, connectionParams, param) {
  var tmp = {};
  if (reconnect !== undefined) {
    tmp.reconnect = Caml_option.valFromOption(reconnect);
  }
  if (connectionParams !== undefined) {
    tmp.connectionParams = Caml_option.valFromOption(connectionParams);
  }
  return new Ws.WebSocketLink({
              options: tmp,
              uri: uri
            });
}

var $$WebSocket = {
  make: make$1
};

var Link = {
  Upload: Upload,
  Context: Context,
  $$WebSocket: $$WebSocket
};

function tryParse(parser, json) {
  try {
    return Relude_Result.pure(Curry._1(parser, json));
  }
  catch (exn){
    return Relude_Result.error(/* ExceptionThrown */0);
  }
}

function parseApolloError(apolloError) {
  return {
          TAG: /* GraphQLError */0,
          message: apolloError.message,
          graphqlErrors: Caml_option.nullable_to_opt(apolloError.graphQLErrors),
          networkError: Caml_option.nullable_to_opt(apolloError.networkError)
        };
}

function dataGet(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.data;
              }), (function (prim) {
                if (prim == null) {
                  return ;
                } else {
                  return Caml_option.some(prim);
                }
              }), param);
}

function errorGet(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.error;
              }), (function (prim) {
                if (prim == null) {
                  return ;
                } else {
                  return Caml_option.some(prim);
                }
              }), param);
}

function refetch(response, json) {
  return response.refetch(Js_null_undefined.fromOption(json));
}

var QueryResponse = {
  dataGet: dataGet,
  errorGet: errorGet,
  refetch: refetch
};

function dataGet$1(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.data;
              }), (function (prim) {
                if (prim == null) {
                  return ;
                } else {
                  return Caml_option.some(prim);
                }
              }), param);
}

function errorGet$1(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.error;
              }), (function (prim) {
                if (prim == null) {
                  return ;
                } else {
                  return Caml_option.some(prim);
                }
              }), param);
}

var MutationResponse = {
  dataGet: dataGet$1,
  errorGet: errorGet$1
};

function subscribe(onData, onError, onCompleted, t) {
  return t.subscribe({
              next: onData,
              error: Js_null_undefined.fromOption(onError),
              complete: Js_null_undefined.fromOption(onCompleted)
            });
}

var SubscriptionResponse = {
  subscribe: subscribe
};

function processResponse(loadingGet, errorGet, dataGet, parser, decoder) {
  return Relude_IO.fromResult(Relude_Result.flatMap((function (param) {
                    return Relude_Result.flatMap(decoder, Relude_Result.flatMap(parser, Relude_Result.fromOption(/* EmptyData */2, dataGet)));
                  }), Relude_Result.flatMap((function (param) {
                        var e = Relude_Option.map(parseApolloError, errorGet);
                        if (e !== undefined) {
                          return Relude_Result.error(e);
                        } else {
                          return {
                                  TAG: /* Ok */0,
                                  _0: undefined
                                };
                        }
                      }), Relude_Result.map((function (param) {
                            
                          }), Relude_Result.fromOption(/* InLoadingState */1, Relude_Option.keep(Relude_Globals.inverse)(Relude_Option.pure(loadingGet)))))));
}

function queryResponse(parser, decoder, response) {
  return processResponse(response.loading, errorGet(response), dataGet(response), parser, decoder);
}

function mutationResponse(parser, decoder, response) {
  return processResponse(response.loading, errorGet$1(response), dataGet$1(response), parser, decoder);
}

function fromIo(io) {
  return Curry._2(Relude_IO.mapError, (function (param) {
                
              }), Relude_IO.catchError((function (param) {
                    return Relude_Globals.$great$great(Relude_AsyncResult.completeError, Relude_IO.pure, param);
                  }), Relude_IO.map(Relude_AsyncResult.fromAsyncData, io)));
}

var Result = {
  init: Relude_AsyncResult.init,
  loading: Relude_AsyncResult.loading,
  reloadingOk: Relude_AsyncResult.reloadingOk,
  reloadingError: Relude_AsyncResult.reloadingError,
  completeOk: Relude_AsyncResult.completeOk,
  completeError: Relude_AsyncResult.completeError,
  ok: Relude_AsyncResult.ok,
  error: Relude_AsyncResult.error,
  isInit: Relude_AsyncResult.isInit,
  isLoading: Relude_AsyncResult.isLoading,
  isReloading: Relude_AsyncResult.isReloading,
  isComplete: Relude_AsyncResult.isComplete,
  isBusy: Relude_AsyncResult.isBusy,
  isIdle: Relude_AsyncResult.isIdle,
  isEmpty: Relude_AsyncResult.isEmpty,
  isNotEmpty: Relude_AsyncResult.isNotEmpty,
  isOk: Relude_AsyncResult.isOk,
  isError: Relude_AsyncResult.isError,
  isReloadingOk: Relude_AsyncResult.isReloadingOk,
  isReloadingError: Relude_AsyncResult.isReloadingError,
  isCompleteOk: Relude_AsyncResult.isCompleteOk,
  isCompleteError: Relude_AsyncResult.isCompleteError,
  getOk: Relude_AsyncResult.getOk,
  getError: Relude_AsyncResult.getError,
  getReloadingOk: Relude_AsyncResult.getReloadingOk,
  getReloadingError: Relude_AsyncResult.getReloadingError,
  getCompleteOk: Relude_AsyncResult.getCompleteOk,
  getCompleteError: Relude_AsyncResult.getCompleteError,
  toBusy: Relude_AsyncResult.toBusy,
  toIdle: Relude_AsyncResult.toIdle,
  map: Relude_AsyncResult.map,
  mapError: Relude_AsyncResult.mapError,
  tap: Relude_AsyncResult.tap,
  tapInit: Relude_AsyncResult.tapInit,
  tapLoading: Relude_AsyncResult.tapLoading,
  tapReloading: Relude_AsyncResult.tapReloading,
  tapComplete: Relude_AsyncResult.tapComplete,
  tapEmpty: Relude_AsyncResult.tapEmpty,
  tapNotEmpty: Relude_AsyncResult.tapNotEmpty,
  tapByValue: Relude_AsyncResult.tapByValue,
  tapOk: Relude_AsyncResult.tapOk,
  tapError: Relude_AsyncResult.tapError,
  apply: Relude_AsyncResult.apply,
  pure: Relude_AsyncResult.pure,
  bind: Relude_AsyncResult.bind,
  flatMap: Relude_AsyncResult.flatMap,
  flatten: Relude_AsyncResult.flatten,
  fold: Relude_AsyncResult.fold,
  foldLazy: Relude_AsyncResult.foldLazy,
  foldByValue: Relude_AsyncResult.foldByValue,
  foldByValueLazy: Relude_AsyncResult.foldByValueLazy,
  fromAsyncData: Relude_AsyncResult.fromAsyncData,
  toAsyncData: Relude_AsyncResult.toAsyncData,
  eqBy: Relude_AsyncResult.eqBy,
  WithError: Relude_AsyncResult.WithError,
  fromIo: fromIo
};

var $$Response = {
  init: Relude_AsyncData.init,
  loading: Relude_AsyncData.loading,
  reloading: Relude_AsyncData.reloading,
  complete: Relude_AsyncData.complete,
  isInit: Relude_AsyncData.isInit,
  isLoading: Relude_AsyncData.isLoading,
  isReloading: Relude_AsyncData.isReloading,
  isComplete: Relude_AsyncData.isComplete,
  isBusy: Relude_AsyncData.isBusy,
  isIdle: Relude_AsyncData.isIdle,
  isEmpty: Relude_AsyncData.isEmpty,
  isNotEmpty: Relude_AsyncData.isNotEmpty,
  toBusy: Relude_AsyncData.toBusy,
  toIdle: Relude_AsyncData.toIdle,
  getValue: Relude_AsyncData.getValue,
  getReloading: Relude_AsyncData.getReloading,
  getComplete: Relude_AsyncData.getComplete,
  fold: Relude_AsyncData.fold,
  foldLazy: Relude_AsyncData.foldLazy,
  foldByValue: Relude_AsyncData.foldByValue,
  foldByValueLazy: Relude_AsyncData.foldByValueLazy,
  map: Relude_AsyncData.map,
  Functor: Relude_AsyncData.Functor,
  BsFunctorExtensions: Relude_AsyncData.BsFunctorExtensions,
  flipMap: Relude_AsyncData.flipMap,
  $$void: Relude_AsyncData.$$void,
  voidRight: Relude_AsyncData.voidRight,
  voidLeft: Relude_AsyncData.voidLeft,
  flap: Relude_AsyncData.flap,
  tap: Relude_AsyncData.tap,
  tapInit: Relude_AsyncData.tapInit,
  tapLoading: Relude_AsyncData.tapLoading,
  tapReloading: Relude_AsyncData.tapReloading,
  tapComplete: Relude_AsyncData.tapComplete,
  tapEmpty: Relude_AsyncData.tapEmpty,
  tapNotEmpty: Relude_AsyncData.tapNotEmpty,
  tapByValue: Relude_AsyncData.tapByValue,
  apply: Relude_AsyncData.apply,
  Apply: Relude_AsyncData.Apply,
  BsApplyExtensions: Relude_AsyncData.BsApplyExtensions,
  applyFirst: Relude_AsyncData.applyFirst,
  applySecond: Relude_AsyncData.applySecond,
  map2: Relude_AsyncData.map2,
  map3: Relude_AsyncData.map3,
  map4: Relude_AsyncData.map4,
  map5: Relude_AsyncData.map5,
  tuple2: Relude_AsyncData.tuple2,
  tuple3: Relude_AsyncData.tuple3,
  tuple4: Relude_AsyncData.tuple4,
  tuple5: Relude_AsyncData.tuple5,
  mapTuple2: Relude_AsyncData.mapTuple2,
  mapTuple3: Relude_AsyncData.mapTuple3,
  mapTuple4: Relude_AsyncData.mapTuple4,
  mapTuple5: Relude_AsyncData.mapTuple5,
  pure: Relude_AsyncData.pure,
  Applicative: Relude_AsyncData.Applicative,
  BsApplicativeExtensions: Relude_AsyncData.BsApplicativeExtensions,
  liftA1: Relude_AsyncData.liftA1,
  all: Relude_AsyncData.all,
  bind: Relude_AsyncData.bind,
  Monad: Relude_AsyncData.Monad,
  BsMonadExtensions: Relude_AsyncData.BsMonadExtensions,
  flatMap: Relude_AsyncData.flatMap,
  flatten: Relude_AsyncData.flatten,
  composeKleisli: Relude_AsyncData.composeKleisli,
  flipComposeKleisli: Relude_AsyncData.flipComposeKleisli,
  liftM1: Relude_AsyncData.liftM1,
  when_: Relude_AsyncData.when_,
  unless: Relude_AsyncData.unless,
  alt: Relude_AsyncData.alt,
  Alt: Relude_AsyncData.Alt,
  orElse: Relude_AsyncData.orElse,
  eqBy: Relude_AsyncData.eqBy,
  Eq: Relude_AsyncData.Eq,
  showBy: Relude_AsyncData.showBy,
  Show: Relude_AsyncData.Show,
  Infix: Relude_AsyncData.Infix,
  processResponse: processResponse,
  queryResponse: queryResponse,
  mutationResponse: mutationResponse,
  Result: Result
};

function recordToTuple(param) {
  return [
          param.field,
          param.resolver
        ];
}

function keyed(key, resolvers) {
  return Js_dict.fromArray([[
                key,
                Js_dict.fromArray(Curry._2(Relude_Array.map, recordToTuple, resolvers))
              ]]);
}

function queries(resolvers) {
  return keyed("Query", resolvers);
}

function mutations(resolvers) {
  return keyed("Mutation", resolvers);
}

var Resolvers = {
  recordToTuple: recordToTuple,
  keyed: keyed,
  queries: queries,
  mutations: mutations
};

var Utilities = {};

function fromString(t) {
  switch (t) {
    case "cache-and-network" :
        return /* CacheAndNetwork */1;
    case "cache-first" :
        return /* CacheFirst */0;
    case "cache-only" :
        return /* CacheOnly */3;
    case "network-only" :
        return /* NetworkOnly */2;
    case "no-cache" :
        return /* NoCache */4;
    case "standby" :
        return /* Standby */5;
    default:
      return ;
  }
}

function toString(str) {
  switch (str) {
    case /* CacheFirst */0 :
        return "cache-first";
    case /* CacheAndNetwork */1 :
        return "cache-and-network";
    case /* NetworkOnly */2 :
        return "network-only";
    case /* CacheOnly */3 :
        return "cache-only";
    case /* NoCache */4 :
        return "no-cache";
    case /* Standby */5 :
        return "standby";
    
  }
}

var FetchPolicy = {
  fromString: fromString,
  toString: toString
};

function make$2(prim, prim$1, prim$2) {
  var tmp = {
    mutation: prim
  };
  if (prim$1 !== undefined) {
    tmp.variables = Caml_option.valFromOption(prim$1);
  }
  return tmp;
}

var MutateOptions = {
  make: make$2
};

function mutate(mutation, variables, client) {
  var tmp = {
    mutation: mutation
  };
  if (variables !== undefined) {
    tmp.variables = Caml_option.valFromOption(variables);
  }
  return client.mutate(tmp);
}

function make$3(prim, prim$1, prim$2) {
  var tmp = {
    query: prim
  };
  if (prim$1 !== undefined) {
    tmp.variables = Caml_option.valFromOption(prim$1);
  }
  return tmp;
}

var QueryOptions = {
  make: make$3
};

function query(queryArg, variables, client) {
  var tmp = {
    query: queryArg
  };
  if (variables !== undefined) {
    tmp.variables = Caml_option.valFromOption(variables);
  }
  return client.query(tmp);
}

function subscribe$1(query, variables, client) {
  var tmp = {
    query: query
  };
  if (variables !== undefined) {
    tmp.variables = Caml_option.valFromOption(variables);
  }
  return client.subscribe(tmp);
}

function make$4(fetchPolicy) {
  return {
          fetchPolicy: toString(fetchPolicy)
        };
}

function fetchPolicyGet(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.fetchPolicy;
              }), fromString, param);
}

var Options = {
  make: make$4,
  fetchPolicyGet: fetchPolicyGet
};

function make$5(prim, prim$1, prim$2, prim$3) {
  var tmp = {};
  if (prim !== undefined) {
    tmp.mutate = Caml_option.valFromOption(prim);
  }
  if (prim$1 !== undefined) {
    tmp.query = Caml_option.valFromOption(prim$1);
  }
  if (prim$2 !== undefined) {
    tmp.watchQuery = Caml_option.valFromOption(prim$2);
  }
  return tmp;
}

var DefaultOptions = {
  Options: Options,
  make: make$5
};

var Options$1 = {
  DefaultOptions: DefaultOptions
};

function make$6(cache, connectToDevTools, defaultOptions, headers, link, queryDeduplication, resolvers, ssrForceFetchDelay, ssrMode, typeDefs, uri) {
  return function (param) {
    return Relude_Globals.$great$great((function (param) {
                  var tmp = {
                    cache: cache,
                    link: link
                  };
                  if (defaultOptions !== undefined) {
                    tmp.defaultOptions = Caml_option.valFromOption(defaultOptions);
                  }
                  if (connectToDevTools !== undefined) {
                    tmp.connectToDevTools = Caml_option.valFromOption(connectToDevTools);
                  }
                  if (headers !== undefined) {
                    tmp.headers = Caml_option.valFromOption(headers);
                  }
                  if (queryDeduplication !== undefined) {
                    tmp.queryDeduplication = Caml_option.valFromOption(queryDeduplication);
                  }
                  if (resolvers !== undefined) {
                    tmp.resolvers = Caml_option.valFromOption(resolvers);
                  }
                  if (ssrForceFetchDelay !== undefined) {
                    tmp.ssrForceFetchDelay = Caml_option.valFromOption(ssrForceFetchDelay);
                  }
                  if (ssrMode !== undefined) {
                    tmp.ssrMode = Caml_option.valFromOption(ssrMode);
                  }
                  if (typeDefs !== undefined) {
                    tmp.typeDefs = Caml_option.valFromOption(typeDefs);
                  }
                  if (uri !== undefined) {
                    tmp.uri = Caml_option.valFromOption(uri);
                  }
                  return tmp;
                }), (function (prim) {
                  return new Client.ApolloClient(prim);
                }), param);
  };
}

var Client$1 = {
  FetchPolicy: FetchPolicy,
  MutateOptions: MutateOptions,
  mutate: mutate,
  QueryOptions: QueryOptions,
  query: query,
  subscribe: subscribe$1,
  Options: Options$1,
  make: make$6
};

function promiseThunkToReludeIO(promiseThunk) {
  return Curry._2(Relude_IO.mapError, (function (exn) {
                return {
                        TAG: /* GraphQLError */0,
                        message: Relude_Option.getOrElse("An unknown error occurred while making an Apollo request", exn.message).replace("GraphQL error: ", ""),
                        graphqlErrors: undefined,
                        networkError: undefined
                      };
              }), PromiseUtils.lazyPromiseToReludeIO(promiseThunk));
}

function tryParseThing(parser, json) {
  try {
    return Relude_Result.pure(Curry._1(parser, json));
  }
  catch (raw_obj){
    var obj = Caml_js_exceptions.internalToOCamlException(raw_obj);
    if (obj.RE_EXN_ID === Js_exn.$$Error) {
      return Relude_Result.error({
                  TAG: /* ParseError */2,
                  _0: obj._1
                });
    }
    throw obj;
  }
}

function tryDecodeThing(decoder) {
  return function (param) {
    return Relude_Globals.$great$great(decoder, (function (param) {
                  return Relude_Result.fromOption(/* DecodeError */3, param);
                }), param);
  };
}

function CreateQuery(Config) {
  var graphqlQueryAST = Client.gql(Config.query);
  var query$1 = function (variables, client) {
    return Curry._2(Relude_IO.mapError, ApolloError.sToT, Relude_IO.flatMap((function (param) {
                      return queryResponse((function (param) {
                                    return tryParseThing((function (param) {
                                                  return Relude_Globals.$great$great((function (prim) {
                                                                return prim;
                                                              }), Config.parse, param);
                                                }), param);
                                  }), (function (param) {
                                    return Relude_Globals.$great$great(Config.decode, (function (param) {
                                                  return Relude_Result.fromOption(/* DecodeError */3, param);
                                                }), param);
                                  }), param);
                    }), promiseThunkToReludeIO(function (param) {
                        return query(graphqlQueryAST, Caml_option.some(Curry._1(Config.variables, variables)), client);
                      })));
  };
  var queryStoreError = function (variables, client) {
    return Curry._2(Relude_IO.mapError, Store.graphQL, query$1(variables, client));
  };
  var queryResult = function (variables, client) {
    return Relude_IO.catchError((function (param) {
                  return Relude_Globals.$great$great(Relude_Result.error, Relude_IO.pure, param);
                }), Relude_IO.map(Relude_Result.ok, query$1(variables, client)));
  };
  var queryAsyncData = function (variables, client) {
    return Relude_IO.map(Relude_AsyncData.complete, query$1(variables, client));
  };
  var queryAsyncDataStoreError = function (variables, client) {
    return Curry._2(Relude_IO.mapError, Store.graphQL, Relude_IO.map(Relude_AsyncData.complete, query$1(variables, client)));
  };
  var queryAsyncResult = function (variables, client) {
    return Curry._2(Relude_IO.mapError, (function (param) {
                  return /* Void */1;
                }), Relude_IO.catchError((function (param) {
                      return Relude_Globals.$great$great(Relude_AsyncResult.completeError, Relude_IO.pure, param);
                    }), Relude_IO.bimap(Relude_AsyncResult.ok, Store.graphQL, query$1(variables, client))));
  };
  return {
          graphqlQueryAST: graphqlQueryAST,
          query: query$1,
          queryStoreError: queryStoreError,
          queryResult: queryResult,
          queryAsyncData: queryAsyncData,
          queryAsyncDataStoreError: queryAsyncDataStoreError,
          queryAsyncResult: queryAsyncResult
        };
}

function CreateMutation(Config) {
  var graphqlMutationAST = Client.gql(Config.query);
  var mutate$1 = function (variables, client) {
    return Curry._2(Relude_IO.mapError, ApolloError.sToT, Relude_IO.flatMap((function (param) {
                      return mutationResponse((function (param) {
                                    return tryParseThing((function (param) {
                                                  return Relude_Globals.$great$great((function (prim) {
                                                                return prim;
                                                              }), Config.parse, param);
                                                }), param);
                                  }), (function (param) {
                                    return Relude_Globals.$great$great(Config.decode, (function (param) {
                                                  return Relude_Result.fromOption(/* DecodeError */3, param);
                                                }), param);
                                  }), param);
                    }), promiseThunkToReludeIO(function (param) {
                        return mutate(graphqlMutationAST, Caml_option.some(Curry._1(Config.variables, variables)), client);
                      })));
  };
  var mutateStoreError = function (variables, client) {
    return Curry._2(Relude_IO.mapError, Store.graphQL, mutate$1(variables, client));
  };
  var mutateResult = function (variables, client) {
    return Relude_IO.catchError((function (param) {
                  return Relude_Globals.$great$great(Relude_Result.error, Relude_IO.pure, param);
                }), Relude_IO.map(Relude_Result.ok, mutate$1(variables, client)));
  };
  var mutateResultStore = function (variables, client) {
    return Curry._2(Relude_IO.mapError, (function (param) {
                  return /* Void */1;
                }), Relude_IO.catchError((function (param) {
                      return Relude_Globals.$great$great(Relude_Result.error, Relude_IO.pure, param);
                    }), Relude_IO.bimap(Relude_Result.ok, Store.graphQL, mutate$1(variables, client))));
  };
  var mutateAsyncData = function (variables, client) {
    return Relude_IO.map(Relude_AsyncData.complete, mutate$1(variables, client));
  };
  var mutateAsyncResult = function (variables, client) {
    return Curry._2(Relude_IO.mapError, (function (param) {
                  return /* Void */1;
                }), Relude_IO.catchError((function (param) {
                      return Relude_Globals.$great$great(Relude_AsyncResult.completeError, Relude_IO.pure, param);
                    }), Relude_IO.bimap(Relude_AsyncResult.ok, Store.graphQL, mutate$1(variables, client))));
  };
  var mutateAsycResultApolloError = function (variables, client) {
    return fromIo(mutateAsyncData(variables, client));
  };
  return {
          graphqlMutationAST: graphqlMutationAST,
          mutate: mutate$1,
          mutateStoreError: mutateStoreError,
          mutateResult: mutateResult,
          mutateResultStore: mutateResultStore,
          mutateAsyncData: mutateAsyncData,
          mutateAsyncResult: mutateAsyncResult,
          mutateAsycResultApolloError: mutateAsycResultApolloError
        };
}

function CreateSubscription(Config) {
  var graphQLSubscriptionAST = Client.gql(Config.query);
  var subscribe$2 = function (onCompleted, variables, onResponse) {
    var partial_arg = (function (param) {
        return Relude_Globals.$great$great((function (param) {
                      return Relude_Globals.$great$great(Relude_Result.error, onResponse, param);
                    }), (function (param) {
                      return Relude_IO.unsafeRunAsync((function (param) {
                                    return Relude_Result.fold(Relude_Globals.id, Relude_Globals.id, param);
                                  }), param);
                    }), param);
      });
    var partial_arg$1 = function (param) {
      return subscribe((function (response) {
                    return Relude_IO.unsafeRunAsync((function (param) {
                                  return Relude_Result.fold(Relude_Globals.id, Relude_Globals.id, param);
                                }), Curry._1(onResponse, Curry._2(Relude_Result.mapError, ApolloError.sToT, Relude_Result.flatMap((function (param) {
                                              return Relude_Globals.$great$great(Config.decode, (function (param) {
                                                            return Relude_Result.fromOption(/* DecodeError */3, param);
                                                          }), param);
                                            }), tryParseThing((function (param) {
                                                  return Relude_Globals.$great$great((function (prim) {
                                                                return prim;
                                                              }), Config.parse, param);
                                                }), response.data)))));
                  }), partial_arg, onCompleted, param);
    };
    var partial_arg$2 = Caml_option.some(Curry._1(Config.variables, variables));
    var partial_arg$3 = function (param) {
      return subscribe$1(graphQLSubscriptionAST, partial_arg$2, param);
    };
    return function (param) {
      return Relude_Globals.$great$great(partial_arg$3, partial_arg$1, param);
    };
  };
  return {
          graphQLSubscriptionAST: graphQLSubscriptionAST,
          subscribe: subscribe$2
        };
}

exports.Cache = Cache;
exports.Link = Link;
exports.tryParse = tryParse;
exports.parseApolloError = parseApolloError;
exports.QueryResponse = QueryResponse;
exports.MutationResponse = MutationResponse;
exports.SubscriptionResponse = SubscriptionResponse;
exports.$$Response = $$Response;
exports.Resolvers = Resolvers;
exports.Utilities = Utilities;
exports.Client = Client$1;
exports.promiseThunkToReludeIO = promiseThunkToReludeIO;
exports.tryParseThing = tryParseThing;
exports.tryDecodeThing = tryDecodeThing;
exports.CreateQuery = CreateQuery;
exports.CreateMutation = CreateMutation;
exports.CreateSubscription = CreateSubscription;
/* Store Not a pure module */
